<template>
  <div>
    <Loading v-if="pageLoading" />
    <CRow v-else>
      <CCol lg="12">
        <CDataTable
          class="mb-0 table-outline bg-white"
          hover
          :items="tableItems"
          :fields="tableFields"
          table-filter
          itemps-per-page-select
          :items-per-page="10"
          sorter
          :sorterValue.sync="tableSorter"
          pagination
          v-if="!pageLoading"
        >
          <td slot="id" class="text-center" slot-scope="{ item }">
            <strong>{{ item.id }}</strong>
          </td>
          <td slot="summary" class="text-center" slot-scope="{ item }">
            <strong>{{ item.summary }}</strong>
          </td>
          <!-- <template #priority="{item}">
            <td class="text-center">
              <CBadge :color="getPriorityBadge(item.priority)">{{item.priority}}</CBadge>
            </td>
          </template>-->
          <!-- <td slot="assigned" slot-scope="{item}" class="text-center">
            <strong>{{item.assigned_to}}</strong>
          </td>-->
          <template #status="{ item }">
            <td class="text-right">
              <CBadge :color="getBadge(item.status)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #creation_time="{ item }">
            <td class="text-right">
              <strong>{{
                new Date(item.creation_time) | dateFormat("YY-MM-DD HH:mm")
              }}</strong>
            </td>
          </template>
          <template #last_change_time="{ item }">
            <td class="text-right">
              <strong>{{
                new Date(item.last_change_time) | dateFormat("YY-MM-DD HH:mm")
              }}</strong>
            </td>
          </template>
          <template #show_details="{ item }">
            <td class="py-2">
              <CButton
                size="sm"
                color="primary"
                v-on:click="detailOnClick(item.id, item.summary)"
                >詳細</CButton
              >
            </td>
          </template>
        </CDataTable>
        <!-- start_detailModal -->
        <CModal
          :show.sync="detailModal"
          color="dark"
          :closeOnBackdrop="false"
          size="xl"
          :centered="true"
        >
          <template v-if="modalLoading">
            <Loading
              class="text-center"
              style="padding-top: 1rem; padding-bottom: 9rem"
            />
          </template>
          <template #body-wrapper v-if="!modalLoading">
            <Loading v-if="sutatusUpdateLoading" />
            <div
              v-for="inquiryDetailContent in inquiryDetailContents"
              :key="inquiryDetailContent.index"
            >
              <CRow
                v-for="(inquiryDetail, index) in inquiryDetailContent"
                :key="inquiryDetail.id"
              >
                <CCol lg="1"></CCol>
                <CCol lg="10" style="padding-top: 2rem">
                  <CCard>
                    <CCardHeader>
                      {{ inquiryDetail.time }}
                    </CCardHeader>
                    <CCardBody>
                      {{ inquiryDetail.text }}
                    </CCardBody>
                    <CCardFooter>
                      <p v-if="index === 0">{{ userName }}</p>
                      <p v-else>リバティースタッフ</p>
                    </CCardFooter>
                  </CCard>
                </CCol>
                <CCol lg="1"></CCol>
              </CRow>
            </div>
            <div
              v-for="inquiryDetailContent in inquiryDetailContents"
              :key="inquiryDetailContent.index"
            >
              <CRow>
                <CCol lg="1"></CCol>
                <CCol lg="3">
                  <CButton
                    v-if="1 < inquiryDetailContent.length"
                    :size="sm"
                    @click="statusUpdate"
                    color="success"
                    >確認しました
                  </CButton>
                </CCol>
              </CRow>
            </div>
          </template>
          <template #header>
            {{inquiryDetailSummary}}
          </template>
          <template #footer>
            <CButton @click="detailModal = false" color="secondary"
              >閉じる</CButton
            >
          </template>
        </CModal>
        <!-- end_detailModal -->
      </CCol>
    </CRow>

    <!-- start_completeModal -->
    <CModal
      :show.sync="completeModal"
      color="success"
      closeOnBackdrop
      :centered="true"
    >
      <p>ステータス内容を更新しました</p>
      <template #header>
      ステータス更新完了
      </template>
      <template #footer>
        <CButton @click="completeModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_completeModal -->

    <!-- start_statusUpdateErrorModal -->
    <CModal
      :show.sync="statusUpdateErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>ステータス更新ができませんでした</p>
      <p>「閉じる」をクリックし、時間をおいて改めて更新してください</p>
      <template #header>
      ステータス更新エラー
      </template>
      <template #footer>
        <CButton @click="statusUpdateErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_statusUpdateErrorModal -->

    <!-- start_searchErrorModal -->
    <CModal
      :show.sync="searchErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>お問合せ内容が取得できません</p>
      <p>「閉じる」をクリックし、時間をおいて改めて送信してください</p>
      <template #header>
      情報取得エラー
      </template>
      <template #footer>
        <CButton @click="searchErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_searchErrorModal -->

    <!-- start_bugzillaLoginErrorModal -->
    <CModal
      :show.sync="bugzillaLoginErrorModal"
      color="danger"
      closeOnBackdrop
      :centered="true"
    >
      <p>お問合せ内容を表示できません</p>
      <p>「閉じる」をクリックし、時間をおいて改めて送信してください</p>
      <template #header>
      情報取得エラー
      </template>
      <template #footer>
        <CButton @click="bugzillaLoginErrorModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end_bugzillaLoginErrorModal -->
         
  </div>
</template>

<script>
import axios from "axios";
import inquiryData from "../assets/inquiryData.json";
import inquiryLoginUserData from "../assets/inquiryLoginUserData.json";
import inquiryRequestURL from "../assets/inquiryRequestURL.json";
import Loading from "../components/loading";

export default {
  name: "InquiryList",
  components: {
    Loading,
  },
  data() {
    return {
       
      userName: this.$keycloak.userName,
      commentCreator: inquiryLoginUserData.email,
      token: "",
      detailInquiryId: 0,
      inquiryDetailContents: [],
      inquiryDetailSummary: "",
      detailModal: false,
      completeModal: false,
      statusUpdateErrorModal: false,
      searchErrorModal: false,
      bugzillaLoginErrorModal: false,
      pageLoading: false,
      modalLoading: false,
      sutatusUpdateLoading: false,
      collapseDuration: 0,
      tableSorter: {
        column: "id",
        asc: false,
      },
      tableItems: [],
      tableFields: [
        { key: "id", label: "お問合せ番号", _classes: "text-center bg-light" },
        { key: "summary", label: "概要", _classes: "text-center bg-light" },
        // { key: "priority", label: "優先度", _classes: "text-center" },
        // { key: "assigned_to", label: "担当者", _classes: "text-left" },
        { key: "status", label: "ステータス", _classes: "text-right bg-light" },
        { key: "creation_time", label: "登録日時", _classes: "text-right bg-light" },
        {
          key: "last_change_time",
          label: "最終更新日時",
          _classes: "text-right bg-light",
        },
        {
          key: "show_details",
          label: "",
          _style: "width:1%",
          _classes: " bg-light",
          sorter: false,
          filter: false,
        },
      ],
    };
  },
  beforeMount() {
    //console.log("ページ更新11");
    //TODO:ページ読み込み時にユーザーの権限取得してページの表示非表示の判断するように処理すること
    this.getInquiries();
  },
  methods: {
    statusUpdate() {
      //ローディング表示
      this.sutatusUpdateLoading = true;

      //更新リクエストで送信するデータ
      var updateStatusInfo = {
        ids: [this.detailInquiryId],
        status: inquiryData.status[4],
        resolution: inquiryData.resolution,
      };
      //ステータス更新リクエスト
      var statusUpdateRequest =
        inquiryRequestURL.URL +
        "/rest/bug/" +
        this.detailInquiryId +
        "?token=" +
        this.token;
      axios
        .put(statusUpdateRequest, updateStatusInfo)
        .then((resp) => {
          console.log("statusUpdateSuccess");
          console.log(resp);
          //詳細ダイアログ閉じる
          this.detailModal = false;

          //ローディング非表示
          this.sutatusUpdateLoading = false;

          //完了ダイアログ表示
          this.completeModal = true;

          this.getInquiries();
        })
        .catch((err) => {
             

          console.log("statusUpdateFailed");
          console.log(err);
          //詳細ダイアログ閉じる
          this.detailModal = false;

          //ローディング非表示
          this.sutatusUpdateLoading = false;
          this.statusUpdateErrorModal = true;
        });
    },
    detailOnClick(userInquiryId, inquirySummary) {
      //ローディングアニメーション表示
      this.modalLoading = true;

      //モーダル表示前に中のデータクリア
      this.inquiryDetailContents = [];

      //ダイアログ表示
      this.detailModal = true;

      //詳細ダイアログ内でIDを使えるように変数に代入
      this.detailInquiryId = userInquiryId;

      //概要の取得
      this.inquiryDetailSummary = inquirySummary;

      //console.log(this.inquiryDetailSummary);
      //個別の問合せ取得
      var bugzillaGetBugDetailRequest =
        inquiryRequestURL.URL +
        "/rest/bug/" +
        userInquiryId +
        "/comment" +
        "?token=" +
        this.token;
      axios
        .get(bugzillaGetBugDetailRequest)
        .then((resp) => {
          // console.log(resp);
          // console.log(resp.data);
          // console.log(resp.data.bugs);
          // const bugs = resp.data.bugs;
          //コメント情報取得
          //console.log(bugs);
          this.inquiryDetailContents = resp.data.bugs[userInquiryId];
          //ローディングアニメーション非表示
          this.modalLoading = false;
        })
        .catch((err) => {
             

          console.log(err);
          this.searchErrorModal = true;
          //ローディングアニメーション非表示
          this.modalLoading = false;
        });
    },
    getInquiries: function () {
      //ローディングアニメーション表示
      this.pageLoading = true;
      //bugzillaにログインする
      //bugzillaアカウント情報
      var email = inquiryLoginUserData.email;
      var password = inquiryLoginUserData.password;
      //var password = "errorPassword";
      //tokenを入れる変数用意
      // var token = "";
      //var userid = "";

      //リクエストで扱う為にユーザーのIDを入れる変数用意
      var userInquiryList = [];

      //ログインリクエスト
      var bugzillaLoginRequest =
        inquiryRequestURL.URL +
        "/rest/login?login=" +
        email +
        "&password=" +
        password;
      axios
        .get(bugzillaLoginRequest)
        .then((resp) => {
          //ログイン成功
          this.token = resp.data.token;
          // userid = resp.data.id;

          console.log("LoginSuccess");

          //お問合せIDを取得するリクエスト
          var userInquiryIdRequest =
            "/rest/users/" + this.$keycloak.userName + "/issues";
          axios
            .get(userInquiryIdRequest, {
              headers: { Authorization: `Bearer ${this.$keycloak.token}` },
            })
            .then((resp) => {
              //restAPIからID取得成功

              //IDの配列を変数に代入
              userInquiryList = resp.data;
              //console.log(resp.data.bugs);
              //console.log("userInquiryGetSuccess");

              //個別ユーザーのお問合せを検索
              var bugzillaBugSerchRequest =
                inquiryRequestURL.URL +
                "/rest/bug?id=" +
                userInquiryList +
                "&token=" +
                this.token;
              axios
                .get(bugzillaBugSerchRequest)
                .then((resp) => {
                  //検索成功
                  console.log("IdSerchSuccess");
                  //リストを変数に代入し表示
                  this.tableItems = resp.data.bugs;

                  //ローディングアニメーション非表示
                  this.pageLoading = false;
                  // console.log(resp);
                  // console.log(this.tableItems);
                  // console.log("")
                })
                .catch((err) => {
             

                  //検索失敗
                  this.searchErrorModal = true;
                  console.log("IdSerchFailed");
                  console.log(err);
                  //ローディングアニメーション非表示
                  this.pageLoading = false;
                });
            })
            .catch((err) => {
             

              //restAPIからID取得失敗
              this.searchErrorModal = true;
              console.log(err);
              console.log("userInquiryGetFailed");

              //ローディングアニメーション非表示
              this.pageLoading = false;
            });
        })
        .catch((err) => {
             
          //ログイン失敗
          this.bugzillaLoginErrorModal = true;
          console.log(err);
          console.log("LoginFailed");
          //ローディングアニメーション非表示
          this.pageLoading = false;
        });
    },

    // getPriorityBadge(priority) {
    //   switch (priority) {
    //     case "不急":
    //       return "success";
    //     case "低順位":
    //       return "secondary";
    //     case "普通":
    //       return "info";
    //     case "緊急":
    //       return "warning";
    //     case "至急":
    //       return "danger";
    //     default:
    //       "primary";
    //   }
    // },
    getBadge(status) {
      switch (status) {
        case inquiryData.status[0]:
          return "danger";

        case inquiryData.status[1]:
          return "warning";

        case inquiryData.status[2]:
          return "warning";

        case inquiryData.status[3]:
          return "warning";

        case inquiryData.status[4]:
          return "success";

        case inquiryData.status[5]:
          return "secondary";
        default:
          "info";
      }
    },
    // addNew: function () {
    //   this.$router.push("/input");
    // },
    // color(value) {
    //   let $color;
    //   if (value <= 25) {
    //     $color = "info";
    //   } else if (value > 25 && value <= 50) {
    //     $color = "success";
    //   } else if (value > 50 && value <= 75) {
    //     $color = "warning";
    //   } else if (value > 75 && value <= 100) {
    //     $color = "danger";
    //   }
    //   return $color;
    // }
  },
};
</script>
